var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { DropdownWidth } from '../utils';
import theme from '../../../theme';
export var WrapperStyles = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: ", ";\n  @media (min-width: ", "px) {\n    width: ", ";\n  }\n  .dropdown-error {\n    position: relative;\n  }\n  .select-component.desktop {\n    input {\n      position: absolute;\n    }\n  }\n"], ["\n  position: relative;\n  width: ", ";\n  @media (min-width: ", "px) {\n    width: ", ";\n  }\n  .dropdown-error {\n    position: relative;\n  }\n  .select-component.desktop {\n    input {\n      position: absolute;\n    }\n  }\n"])), function (_a) {
    var width = _a.width;
    return (width === DropdownWidth.Large ? '100%' : width);
}, theme.grid.resolution.tablet.width, function (_a) {
    var width = _a.width;
    return width;
});
var templateObject_1;
